import type { GalleryItem } from '../types/content'

// Les visuels d'origine de cette section argentine n'étaient pas disponibles
// dans l'historique : réutilisation de visuels existants cohérents + 4 générés.
export const creations: GalleryItem[] = [
  {
    id: 'photophores',
    motif: 'Photophores décoratifs',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b51e6a99-7394-496e-8863-531f7bd90552.jpg',
    alt: 'Photophore en verre décoré de feuilles en faux vitrail, une bougie allumée à l’intérieur',
  },
  {
    id: 'attrape-soleil',
    motif: 'Attrape-soleil',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/bc1f64a1-d84d-40dc-a773-58f1b9152740.jpg',
    alt: 'Attrape-soleil rond en faux vitrail suspendu devant une fenêtre',
  },
  {
    id: 'miroirs',
    motif: 'Miroirs décorés',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6a1e55ee-d0dd-471d-9d53-5e236cd1ed6d.jpg',
    alt: 'Gros plan sur un miroir à la bordure peinte de fleurs en faux vitrail',
  },
  {
    id: 'tableaux',
    motif: 'Tableaux en faux vitrail',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/39d9db38-fcd0-46e5-b17f-21dc0c347a48.jpg',
    alt: 'Petit tableau en faux vitrail représentant des tulipes, dans un cadre en bois',
  },
  {
    id: 'sous-verres',
    motif: 'Sous-verres personnalisés',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4bd2cef8-2641-433b-a515-67b8c5ef878f.jpg',
    alt: 'Sous-verres en verre peints de motifs floraux translucides en faux vitrail',
  },
  {
    id: 'vaisselle',
    motif: 'Vaisselle décorative',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5a5bc7b4-f044-4f69-82f5-519b0f491e6c.jpg',
    alt: 'Assiette et bol en verre décorés de fleurs en faux vitrail, exposés sur une étagère',
  },
]
